import { trace } from "owa-trace";

interface SessionSettingsSections {
    listViewType: unknown;
    consumerAdsExperiment: unknown;
    globalFolderViewState: string | undefined;
    beforeFolderViewBits: Readonly<Record<string, unknown>>;
    afterFolderViewBits: Readonly<Record<string, unknown>>;
}

interface FolderViewProperties {
    isConversationView?: unknown;
    folderViewBits?: string;
}

function getFolderViewProperties(globalFolderViewState: string | undefined): FolderViewProperties {
    if (globalFolderViewState === undefined) {
        return {};
    }
    
    try {
        const parsedFolderViewState: unknown = JSON.parse(globalFolderViewState);
        if (typeof parsedFolderViewState !== "object" ||
            parsedFolderViewState === null ||
            Array.isArray(parsedFolderViewState)) {
            trace.warn("Unexpected GlobalFolderViewState shape in session telemetry.", "analytics");
            return { folderViewBits: globalFolderViewState };
        }
        
        const folderViewState = parsedFolderViewState as Record<string, unknown>;
        const isConversationView = folderViewState.IsConversationView;
        delete folderViewState.IsConversationView;
        
        return {
            isConversationView,
            folderViewBits: JSON.stringify(folderViewState),
        };
    }
    catch {
        trace.warn("Failed to parse GlobalFolderViewState for session telemetry.", "analytics");
        return { folderViewBits: globalFolderViewState };
    }
}

export function serializeSessionSettings({ listViewType, consumerAdsExperiment, globalFolderViewState, beforeFolderViewBits, afterFolderViewBits, }: SessionSettingsSections): string {
    const { isConversationView, folderViewBits } = getFolderViewProperties(globalFolderViewState);
    
    return JSON.stringify({
        ListViewType: listViewType,
        ConsumerAdsExperiment: consumerAdsExperiment,
        IsConversationView: isConversationView,
        ...beforeFolderViewBits,
        FolderViewBits: folderViewBits,
        ...afterFolderViewBits,
    });
}
